<script lang="ts" setup>
import BasicInput from '~/components/form-elements/BasicInput.vue'
import OrderShippingType from '~/enums/order-shipping-type'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const isDostavistaInsideMkad = computed(() => cartStore.orderShippingType === OrderShippingType.DostavistaInsideMkad)
const isRussianPostInternationalParcel = computed(
  () => cartStore.orderShippingType === OrderShippingType.RussianPostInternationalParcel
)
</script>

<template>
  <BlockWithBorder>
    <div class="h4">
      Получатель
    </div>

    <Notification class="mb-6" is-small status="info">
      Все поля обязательны для заполнения.
    </Notification>

    <Notification
      v-if="cartStore.orderShippingType === OrderShippingType.RussianPostInternationalParcel"
      class="mb-6"
      is-small
      status="info"
    >
      Используйте только латинские буквы в&nbsp;имени и&nbsp;фамилии.
    </Notification>

    <div class="row mb-6">
      <div class="column-6 tb12 with-margin-bottom-24">
        <BasicInput v-model="cartStore.form.shippingFirstName" is-required label-text="Имя" />
      </div>
      <div class="column-6 tb12">
        <BasicInput v-model="cartStore.form.shippingLastName" is-required label-text="Фамилия" />
      </div>
    </div>

    <div class="row">
      <div class="column-6 tb12 with-margin-bottom-24">
        <BasicInput v-model="cartStore.form.shippingEmail" is-required label-text="Email" />
      </div>
      <div class="column-6 tb12">
        <BasicInput v-model="cartStore.form.shippingPhoneNumber" is-required label-text="Номер телефона" />
      </div>
    </div>

    <div
      v-if="cartStore.orderShippingType !== null && OrderShippingType.hasAddress(cartStore.orderShippingType)"
      class="mt-6"
    >
      <h4>Адрес</h4>

      <template v-if="cartStore.orderShippingType === OrderShippingType.RussianPostInternationalParcel && cartStore.shippingData">
        <Notification class="mb-6" is-small status="info">
          Используйте только латинские буквы в&nbsp;адресе.
        </Notification>
        <Notification class="mb-6" is-small status="info">
          Поля, отмеченные звёздочкой, обязательны для заполнения.
        </Notification>
        <p class="mb-6">
          Выбранная страна: {{ cartStore.shippingData.countryName }}.
        </p>
      </template>

      <BasicInput
        v-model="cartStore.form.shippingPostcode"
        class="mb-6"
        :is-required="isRussianPostInternationalParcel"
        label-text="Почтовый индекс"
      />

      <BasicInput
        v-if="cartStore.orderShippingType !== OrderShippingType.RussianPostInternationalParcel"
        v-model="cartStore.form.shippingCountry"
        class="mb-6"
        :is-disabled="isDostavistaInsideMkad"
        label-text="Страна"
      />

      <BasicInput
        v-model="cartStore.form.shippingState"
        class="mb-6"
        :is-disabled="isDostavistaInsideMkad"
        label-text="Регион/штат/провинция"
      />

      <BasicInput
        v-model="cartStore.form.shippingCity"
        class="mb-6"
        :is-disabled="isDostavistaInsideMkad"
        :is-required="isRussianPostInternationalParcel"
        label-text="Город / населённый пункт"
      />

      <BasicInput
        v-model="cartStore.form.shippingAddressLine1"
        class="mb-6"
        :is-required="isRussianPostInternationalParcel"
        :label-text="'Название улицы и\xA0номер дома'"
      />

      <BasicInput
        v-model="cartStore.form.shippingAddressLine2"
        :is-required="isRussianPostInternationalParcel"
        label-text="Номер квартиры/офиса"
      />
    </div>

    <!--<h4>Детали</h4>-->
    <!--<BasicTextarea v-model="cartStore.form.comment" class="mb-6" :label-text="'Примечания к\xA0заказу'" />-->
  </BlockWithBorder>
</template>
